import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";

import { FormattedMessage } from "react-intl";
import { editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import { useState } from "react";

import SaveChangesButton from "components/shared/SaveChangesButton";
import ImageUpload from "components/shared/ImageUpload";

const Index = () => {
  const dispatch = useDispatch();
  const {
    handleSubmit,
    reset,
    formState: { errors },
    register,
  } = useForm();

  const [selectedImage, setSelectedImage] = useState({
    preview: null,
    path: "",
  });

  const { loading, section } = useSelector((state) => state.section);

  // get single page by slug
  useEffect(() => {
    dispatch(
      getSection({
        page: "terms",
        slug: "jumbotron",
      })
    );
  }, [dispatch]);

  // reset form with fetched data
  useEffect(() => {
    if (section) {
      reset({
        ...section,
      });

      setSelectedImage({
        preview: null,
        path: section?.image,
      });
    }
  }, [section, reset]);

  const onSubmit = (data) => {
    data.image = selectedImage?.path;

    dispatch(
      editSection({
        slug: "jumbotron",
        page: "terms",
        data: { section: data },
      })
    );
  };

  if (loading) return <Loader />;

  return (
    <div className="acc-form">
      <div className="card">
        <div className="card-head">
          <h4>
            <FormattedMessage id={"termsHead"} />
          </h4>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col lg={12} xs={12}>
                <div className="form-group required">
                  <h5>
                    <FormattedMessage id={"image"} />
                  </h5>

                  <div className="header-image">
                    <ImageUpload
                      selectedImage={selectedImage}
                      setSelectedImage={setSelectedImage}
                    />
                  </div>
                </div>
              </Col>
              <Col lg={6} xs={12}>
                <div className="form-group">
                  <h5>
                    <FormattedMessage id="subTitle" /> ({" "}
                    <FormattedMessage id="arabic-language" /> )
                  </h5>
                  <input
                    type="text"
                    className={`form-control ${
                      errors.subTitle ? "is-invalid" : ""
                    }`}
                    defaultValue={section?.secSubTitle?.ar || ""}
                    {...(errors.secSubTitle && { "aria-invalid": "true" })}
                    {...register("secSubTitle[ar]", { required: true })}
                  />
                  {errors.secSubTitle && (
                    <div className="invalid-feedback">
                      <FormattedMessage id={"thisFieldIsRequired"} />
                    </div>
                  )}
                </div>
              </Col>
              <Col lg={6} xs={12}>
                <div className="form-group">
                  <h5>
                    <FormattedMessage id="subTitle" /> ({" "}
                    <FormattedMessage id="english-language" /> )
                  </h5>
                  <input
                    type="text"
                    className={`form-control ${
                      errors.subTitle ? "is-invalid" : ""
                    }`}
                    defaultValue={section?.secSubTitle?.en || ""}
                    {...(errors.secSubTitle && { "aria-invalid": "true" })}
                    {...register("secSubTitle[en]", { required: true })}
                  />
                  {errors.secSubTitle && (
                    <div className="invalid-feedback">
                      <FormattedMessage id={"thisFieldIsRequired"} />
                    </div>
                  )}
                </div>
              </Col>

              <Col lg={6} xs={12}>
                <div className="form-group">
                  <h5>
                    <FormattedMessage id="title" /> ({" "}
                    <FormattedMessage id="arabic-language" /> )
                  </h5>
                  <input
                    type="text"
                    className={`form-control ${
                      errors.secTitle ? "is-invalid" : ""
                    }`}
                    defaultValue={section?.secTitle?.ar || ""}
                    {...(errors.secTitle && { "aria-invalid": "true" })}
                    {...register("secTitle[ar]", { required: true })}
                  />
                  {errors.secTitle && (
                    <div className="invalid-feedback">
                      <FormattedMessage id={"thisFieldIsRequired"} />
                    </div>
                  )}
                </div>
              </Col>
              <Col lg={6} xs={12}>
                <div className="form-group">
                  <h5>
                    <FormattedMessage id="title" /> ({" "}
                    <FormattedMessage id="english-language" /> )
                  </h5>
                  <input
                    type="text"
                    className={`form-control ${
                      errors.secTitle ? "is-invalid" : ""
                    }`}
                    defaultValue={section?.secTitle?.en || ""}
                    {...(errors.secTitle && { "aria-invalid": "true" })}
                    {...register("secTitle[en]", { required: true })}
                  />
                  {errors.secTitle && (
                    <div className="invalid-feedback">
                      <FormattedMessage id={"thisFieldIsRequired"} />
                    </div>
                  )}
                </div>
              </Col>

              <Col lg={6} xs={12}>
                <div className="form-group">
                  <h5>
                    <FormattedMessage id="description" /> ({" "}
                    <FormattedMessage id="arabic-language" /> )
                  </h5>
                  <textarea
                    className={`form-control ${
                      errors.secDescription ? "is-invalid" : ""
                    }`}
                    defaultValue={section?.secDescription?.ar || ""}
                    {...(errors.secDescription && { "aria-invalid": "true" })}
                    {...register("secDescription[ar]", { required: true })}
                  ></textarea>
                  {errors.secDescription && (
                    <div className="invalid-feedback">
                      <FormattedMessage id={"thisFieldIsRequired"} />
                    </div>
                  )}
                </div>
              </Col>
              <Col lg={6} xs={12}>
                <div className="form-group">
                  <h5>
                    <FormattedMessage id="description" /> ({" "}
                    <FormattedMessage id="english-language" /> )
                  </h5>
                  <textarea
                    className={`form-control ${
                      errors.secDescription ? "is-invalid" : ""
                    }`}
                    defaultValue={section?.secDescription?.en || ""}
                    {...(errors.secDescription && { "aria-invalid": "true" })}
                    {...register("secDescription[en]", { required: true })}
                  ></textarea>
                  {errors.secDescription && (
                    <div className="invalid-feedback">
                      <FormattedMessage id={"thisFieldIsRequired"} />
                    </div>
                  )}
                </div>
              </Col>

              <Col lg={12} xs={12}>
                <SaveChangesButton />
              </Col>
            </Row>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Index;
